export default "__VITE_ASSET__13e13bc9__"